export const iconFontAwesomeSocialSquarePollHorizontal = (
	<i className="fa-solid fa-square-poll-horizontal"></i>
);
